"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSurvey720Result = getSurvey720Result;
exports.updateSurvey720Result = updateSurvey720Result;
var _request = _interopRequireDefault(require("@/utils/request"));
// import { fileURLToPath } from 'url'

function getSurvey720Result(token, hikeId, stageId, userId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/hike-720reports/hikes/${hikeId}/stages/${stageId}/lastUpdate`,
    method: 'get',
    headers
  });
}
function updateSurvey720Result(token, hikeId, stageId, type, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/hike-720reports/hikes/${hikeId}/stages/${stageId}/types/${type}/uploadScores`,
    method: 'post',
    headers,
    data
  });
}